import {CanActivateFn} from '@angular/router';

export const WorkflowGuard: CanActivateFn = (route, state) => true;
